export default {
  'en-US': {
    date: 'MM/DD/YYYY',
    dateShortYear: 'MM/DD/YY',
    yearFirstDate: 'YYYY/MM/DD',
    hyphenDate: 'MM-DD-YYYY',
    yearFirstHyphenDate: 'YYYY-MM-DD',
    dateNoYear: 'MM/DD',
    shortMonthYear: 'MMM YY',
    shortMonthFullYear: 'MMM YYYY',
    time: 'hh:mm a',
    timeWithSeconds: 'hh:mm:ss a',
    fullDateTime: 'MM/DD/YYYY hh:mm a',
    fullDateTimeWithSeconds: 'MM/DD/YYYY hh:mm:ss a',
    dayOfWeekDateNoYear: 'ddd MM/DD',
    timeOnDate: 'hh:mm a on MM/DD/YY',
    shortMonthDateYearTime: 'MMM D, YYYY, h:mm a',
  },
  'en-GB': {
    date: 'DD/MM/YYYY',
    dateShortYear: 'DD/MM/YY',
    yearFirstDate: 'YYYY/MM/DD',
    hyphenDate: 'DD-MM-YYYY',
    yearFirstHyphenDate: 'YYYY-MM-DD',
    dateNoYear: 'DD/MM',
    shortMonthYear: 'MMM YY',
    shortMonthFullYear: 'MMM YYYY',
    time: 'HH:mm',
    timeWithSeconds: 'HH:mm:ss',
    fullDateTime: 'DD/MM/YYYY HH:mm',
    fullDateTimeWithSeconds: 'DD/MM/YYYY HH:mm:ss',
    dayOfWeekDateNoYear: 'ddd DD/MM',
    timeOnDate: 'HH:mm on DD/MM/YY',
    shortMonthDateYearTime: 'MMM D, YYYY, HH:mm',
  },
};
